export const CSS_WEIGHTS = [
  {
    text: "100 (Thin)",
    value: 100
  },
  {
    text: "200 (Extra Light)",
    value: 200
  },
  {
    text: "300 (Light)",
    value: 300
  },
  {
    text: "400 (Normal)",
    value: 400
  },
  {
    text: "500 (Medium)",
    value: 500
  },
  {
    text: "600 (Semi Bold)",
    value: 600
  },
  {
    text: "700 (Bold)",
    value: 700
  },
  {
    text: "800 (Extra Bold)",
    value: 800
  },
  {
    text: "900 (Black)",
    value: 900
  }
];
